import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { FaWhatsapp, FaFacebookF, FaLinkedin, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

// ─── CONTACT FORM EMAIL BUILDER (FOR ADMIN/OWNER) ────────────────────────────────
function buildContactEmail(data, emailLogo) {
  const year = new Date().getFullYear();
  const logoUrl = emailLogo || "https://i.postimg.cc/023xvzzm/vbt-logo-2.png";

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>New Contact Form Message</title>
    </head>
    <body style="margin: 0; padding: 0; background-color: #f0f4f8; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;">
      <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f0f4f8; padding: 40px 0;">
        <tr>
          <td align="center">
            <table width="600" cellpadding="0" cellspacing="0" style="max-width: 600px; width: 100%; background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
              
              <!-- HEADER -->
              <tr>
                <td style="background-color: #FF8C00; text-align: center; padding: 40px 24px;">
                  <img src="${logoUrl}" width="160px" alt="VBT Logo" style="display: block; margin: 0 auto 16px;">
                  <h1 style="margin: 0; color: #ffffff; font-size: 24px; font-weight: 700;">New Contact Form Message</h1>
                  <p style="margin: 8px 0 0; color: rgba(255,255,255,0.9); font-size: 14px;">Someone has reached out through the website contact form</p>
                </td>
              </tr>
              
              <!-- ALERT BANNER -->
              <tr>
                <td style="padding: 24px 28px 0;">
                  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #fff8f0; border-radius: 10px; border: 1px solid #FFD699;">
                    <tr>
                      <td style="width: 4px; background-color: #FF8C00; border-radius: 10px 0 0 10px; padding: 0;">&nbsp;</td>
                      <td style="padding: 14px 16px;">
                        <p style="margin: 0; color: #B85C00; font-size: 13px; font-weight: 600;">📬 Action Required</p>
                        <p style="margin: 4px 0 0; color: #8B4500; font-size: 13px;">A new contact form submission has been received. Please review the details below.</p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              
              <!-- SENDER DETAILS -->
              <tr>
                <td style="padding: 24px 28px 8px;">
                  <p style="margin: 0 0 12px; font-size: 11px; font-weight: 700; color: #999999; text-transform: uppercase; letter-spacing: 1px;">Sender Details</p>
                  <table width="100%" cellpadding="0" cellspacing="0" style="border: 1px solid #EEEEEE; border-radius: 10px; overflow: hidden;">
                    <tr>
                      <td style="padding: 14px 18px; width: 35%; background-color: #FAFAFA; border-bottom: 1px solid #EEEEEE;">
                        <span style="font-size: 16px; margin-right: 8px;">👤</span>
                        <span style="font-weight: 600; color: #444444; font-size: 13px;">Full Name</span>
                      </td>
                      <td style="padding: 14px 18px; border-bottom: 1px solid #EEEEEE;">
                        <span style="color: #111111; font-size: 14px;">${data.name}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 14px 18px; width: 35%; background-color: #FAFAFA; border-bottom: 1px solid #EEEEEE;">
                        <span style="font-size: 16px; margin-right: 8px;">✉️</span>
                        <span style="font-weight: 600; color: #444444; font-size: 13px;">Email Address</span>
                      </td>
                      <td style="padding: 14px 18px; border-bottom: 1px solid #EEEEEE;">
                        <a href="mailto:${data.email}" style="color: #FF8C00; text-decoration: none;">${data.email}</a>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 14px 18px; width: 35%; background-color: #FAFAFA;">
                        <span style="font-size: 16px; margin-right: 8px;">📞</span>
                        <span style="font-weight: 600; color: #444444; font-size: 13px;">Phone Number</span>
                      </td>
                      <td style="padding: 14px 18px;">
                        <span style="color: #111111; font-size: 14px;">${data.phone || '<span style="color: #999999;">Not provided</span>'}</span>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              
              <!-- MESSAGE CONTENT -->
              <tr>
                <td style="padding: 8px 28px 20px;">
                  <p style="margin: 0 0 12px; font-size: 11px; font-weight: 700; color: #999999; text-transform: uppercase; letter-spacing: 1px;">Message Content</p>
                  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #FAFAFA; border: 1px solid #EEEEEE; border-radius: 10px;">
                    <tr>
                      <td style="padding: 18px;">
                        <p style="margin: 0; color: #444444; font-size: 14px; line-height: 1.6;">${data.message.replace(/\n/g, '<br/>')}</p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              
              <!-- CONTACT INFO (No Reply Button) -->
              <tr>
                <td style="padding: 8px 28px 32px;">
                  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #F5F5F5; border-radius: 10px;">
                    <tr>
                      <td style="padding: 14px 18px; text-align: center;">
                        <p style="margin: 0; color: #666666; font-size: 12px;">
                          💡 You can reply directly to: <a href="mailto:${data.email}" style="color: #FF8C00; text-decoration: none;">${data.email}</a>
                        </p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              
              <!-- FOOTER -->
              <tr>
                <td style="background-color: #111111; text-align: center; padding: 24px;">
                  <p style="margin: 0 0 4px; color: #FF8C00; font-size: 13px; font-weight: 700; letter-spacing: 0.5px;">VISION BIRD TECHNOLOGIES</p>
                  <p style="margin: 0; color: #666666; font-size: 12px;">&copy; ${year} &nbsp;•&nbsp; Automated Notification &nbsp;•&nbsp; Do not reply</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </body>
    </html>
  `;
}

// ─── CUSTOMER AUTO-REPLY EMAIL BUILDER ─────────────────────────────────────────
function buildAutoReplyEmail(data, emailLogo) {
  const year = new Date().getFullYear();
  const logoUrl = emailLogo || "https://i.postimg.cc/023xvzzm/vbt-logo-2.png";

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Thank You for Contacting Us</title>
    </head>
    <body style="margin: 0; padding: 0; background-color: #f0f4f8; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;">
      <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f0f4f8; padding: 40px 0;">
        <tr>
          <td align="center">
            <table width="600" cellpadding="0" cellspacing="0" style="max-width: 600px; width: 100%; background-color: #ffffff; border-radius: 16px; overflow: hidden; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
              
              <!-- HEADER -->
              <tr>
                <td style="background-color: #FF8C00; text-align: center; padding: 40px 24px;">
                  <img src="${logoUrl}" width="160px" alt="VBT Logo" style="display: block; margin: 0 auto 16px;">
                  <h1 style="margin: 0; color: #ffffff; font-size: 24px; font-weight: 700;">Thank You for Reaching Out!</h1>
                  <p style="margin: 8px 0 0; color: rgba(255,255,255,0.9); font-size: 14px;">We've received your message and will get back to you shortly</p>
                </td>
              </tr>
              
              <!-- GREETING -->
              <tr>
                <td style="padding: 32px 32px 16px;">
                  <p style="margin: 0; font-size: 16px; color: #222222; line-height: 1.6;">Dear <strong style="color: #FF8C00;">${data.name}</strong>,</p>
                  <p style="margin: 12px 0 0; font-size: 14px; color: #555555; line-height: 1.7;">
                    Thank you for contacting <strong style="color: #FF8C00;">Vision Bird Technologies</strong>. 
                    We have successfully received your message and our team will review it shortly.
                  </p>
                </td>
              </tr>
              
              <!-- MESSAGE SUMMARY -->
              <tr>
                <td style="padding: 8px 32px 16px;">
                  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #FFF8F0; border: 1px solid #FFD699; border-radius: 12px;">
                    <tr>
                      <td style="background-color: #FF8C00; padding: 12px 18px; border-radius: 12px 12px 0 0;">
                        <p style="margin: 0; color: #ffffff; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 1px;">📝 Your Message Summary</p>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 18px;">
                        <p style="margin: 0; color: #555555; font-size: 14px; line-height: 1.6; font-style: italic;">"${data.message.substring(0, 200)}${data.message.length > 200 ? '...' : ''}"</p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              
              <!-- WHAT HAPPENS NEXT -->
              <tr>
                <td style="padding: 8px 32px 16px;">
                  <p style="margin: 0 0 16px; font-size: 11px; font-weight: 700; color: #999999; text-transform: uppercase; letter-spacing: 1px;">What Happens Next?</p>
                  
                  <!-- Step 1 -->
                  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #F0FFF6; border: 1px solid #99E8C0; border-radius: 10px; margin-bottom: 12px;">
                    <tr>
                      <td style="width: 50px; text-align: center; padding: 14px 0 14px 16px; vertical-align: middle;">
                        <span style="font-size: 24px;">⏱️</span>
                      </td>
                      <td style="padding: 14px 16px 14px 0; vertical-align: middle;">
                        <p style="margin: 0 0 4px; font-weight: 700; color: #1A7A45; font-size: 13px;">Quick Response Time</p>
                        <p style="margin: 0; color: #555555; font-size: 13px; line-height: 1.5;">We typically respond within <strong>24 business hours</strong>.</p>
                      </td>
                    </tr>
                  </table>
                  
                  <!-- Step 2 -->
                  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #F0F6FF; border: 1px solid #B3D0FF; border-radius: 10px; margin-bottom: 12px;">
                    <tr>
                      <td style="width: 50px; text-align: center; padding: 14px 0 14px 16px; vertical-align: middle;">
                        <span style="font-size: 24px;">👨‍💼</span>
                      </td>
                      <td style="padding: 14px 16px 14px 0; vertical-align: middle;">
                        <p style="margin: 0 0 4px; font-weight: 700; color: #0055CC; font-size: 13px;">Team Review</p>
                        <p style="margin: 0; color: #555555; font-size: 13px; line-height: 1.5;">Our team will review your inquiry and connect you with the right department.</p>
                      </td>
                    </tr>
                  </table>
                  
                  <!-- Step 3 -->
                  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #FFF8F0; border: 1px solid #FFD699; border-radius: 10px;">
                    <tr>
                      <td style="width: 50px; text-align: center; padding: 14px 0 14px 16px; vertical-align: middle;">
                        <span style="font-size: 24px;">📞</span>
                      </td>
                      <td style="padding: 14px 16px 14px 0; vertical-align: middle;">
                        <p style="margin: 0 0 4px; font-weight: 700; color: #FF8C00; font-size: 13px;">Direct Contact</p>
                        <p style="margin: 0; color: #555555; font-size: 13px; line-height: 1.5;">Need immediate assistance? Call us at <strong>+92 301 6239096</strong></p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              
              <!-- CLOSING TEXT - INSIDE THE TABLE -->
              <tr>
                <td style="padding: 24px 32px 32px;">
                  <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #F9FAFB; border-radius: 12px; border: 1px solid #E5E7EB;">
                    <tr>
                      <td style="padding: 24px; text-align: center;">
                        <p style="margin: 0 0 8px; font-size: 16px; color: #333333; font-weight: 500;">We look forward to assisting you!</p>
                        <p style="margin: 16px 0 0; font-size: 14px; color: #555555;">
                          Best regards,<br>
                          <strong style="color: #FF8C00; font-size: 15px;">Vision Bird Technologies — Customer Support Team</strong>
                        </p>
                        <div style="margin-top: 20px; padding-top: 16px; border-top: 1px solid #E5E7EB;">
                          <p style="margin: 0; font-size: 12px; color: #999999;">
                            <span style="display: inline-block; margin: 0 8px;">📧 info@visionbird.com</span>
                            <span style="display: inline-block; margin: 0 8px;">📞 +92 301 6239096</span>
                          </p>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              
              <!-- FOOTER -->
              <tr>
                <td style="background-color: #111111; text-align: center; padding: 24px;">
                  <p style="margin: 0 0 4px; color: #FF8C00; font-size: 13px; font-weight: 700; letter-spacing: 0.5px;">VISION BIRD TECHNOLOGIES</p>
                  <p style="margin: 0; color: #666666; font-size: 12px;">&copy; ${year} &nbsp;•&nbsp; Please do not reply to this email</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </body>
    </html>
  `;
}

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [emailLogo, setEmailLogo] = useState("");

  // Fetch email logo from Firestore
  useEffect(() => {
    const fetchEmailLogo = async () => {
      try {
        const logosRef = doc(db, "logos", "xrSCDlcVzp10becG8bnW");
        const logosSnap = await getDoc(logosRef);
        if (logosSnap.exists()) {
          const data = logosSnap.data();
          setEmailLogo(data.emailLogo || "");
        }
      } catch (error) {
        console.error("Error fetching email logo:", error);
      }
    };
    fetchEmailLogo();
  }, []);

  // Initialize EmailJS
  useEffect(() => {
    emailjs.init("user_nNOCYOChn23l66IslyoJA");
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();
    setSubmitting(true);

    const { name, email, phone, message } = formData;

    // Basic validation
    if (!name || !email || !message) {
      toast.error("Please fill in all required fields.");
      setSubmitting(false);
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error("Please enter a valid email.");
      setSubmitting(false);
      return;
    }

    try {
      // Send email to admin
      const adminResult = await emailjs.send(
        "newwebsitevbt",
        "template_llrsxxj",
        {
          to_email: "info@visionbird.com",
          subject: `New Contact Message from ${name} - Vision Bird Technologies`,
          message: buildContactEmail(formData, emailLogo),
        },
        "user_nNOCYOChn23l66IslyoJA"
      );
      
      console.log("Admin email sent:", adminResult);

      // Send auto-reply to customer
      const customerResult = await emailjs.send(
        "newwebsitevbt",
        "template_llrsxxj",
        {
          to_email: email,
          subject: "We've received your message - Vision Bird Technologies",
          message: buildAutoReplyEmail(formData, emailLogo),
        },
        "user_nNOCYOChn23l66IslyoJA"
      );
      
      console.log("Customer email sent:", customerResult);

      toast.success("Message sent successfully! We'll get back to you soon.");
      setFormData({ name: "", email: "", phone: "", message: "" });
    } catch (error) {
      console.error("EmailJS error details:", error);
      toast.error(`Failed to send message. Please try again later.`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-section padding-container">
      <div className="page-wrapper">
        <div className="contact-bg">
          <div className="contact-us-form">
            {/* Left Side */}
            <div className="contact-text">
              <h1>GET IN TOUCH</h1>
              <p>Contact us & You'll Hear Back Today</p>
              <div id="contact-action">
                {/* Facebook */}
                <div className="contact-icon">
                  <a href="https://www.facebook.com/VisionBirdTech" target="_blank" rel="noopener noreferrer">
                    <FaFacebookF />
                  </a>
                </div>
                
                {/* Instagram */}
                <div className="contact-icon">
                  <a href="https://www.instagram.com/visionbirdtechnologies/" target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </a>
                </div>
                
                {/* X (Twitter) */}
                <div className="contact-icon">
                  <a href="https://x.com/VisionbirdT" target="_blank" rel="noopener noreferrer">
                    <FaXTwitter />
                  </a>
                </div>
                
                {/* LinkedIn */}
                <div className="contact-icon">
                  <a href="https://www.linkedin.com/in/visionbird/" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                  </a>
                </div>
                
                {/* WhatsApp */}
                <div className="contact-icon">
                  <a href="https://api.whatsapp.com/send?phone=923016239096&text=VisionBirdTechnologies" target="_blank" rel="noopener noreferrer">
                    <FaWhatsapp />
                  </a>
                </div>
              </div>
            </div>

            {/* Right Side - Form */}
            <div className="contact-form">
              <h1>Contact Form</h1>
              <div className="form-data">
                <form onSubmit={handleSubmit}>
                  <div className="form-name">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-email">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-phone">
                    <label htmlFor="phone">Phone (Optional)</label>
                    <input
                      type="tel"
                      name="phone"
                      id="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-message">
                    <label className="message-label" htmlFor="message">
                      Message
                    </label>
                    <textarea
                      name="message"
                      id="message"
                      style={{ minHeight: "206px" }}
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <button className="form-submit send-msg" type="submit" disabled={submitting}>
                    {submitting ? "Sending..." : "Send Message"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;